<template>
  <div>
    <input type="number" v-model="timerDuration" />
    <button @click="startTimer">Start Timer</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timerDuration: 0,
    };
  },
  methods: {
    startTimer() {
      if (this.timerDuration > 0) {
        this.$emit("start-timer", this.timerDuration);
      }
    },
  },
};
</script>
